import { useState } from 'react';

const useCustomHook = () => {
  const [loading, setLoading] = useState(false);
  const [loadingSupport, setLoadingSupport] = useState(false);

  const [categoryLoading, setCategoryLoading] = useState(false);
  const [, setFilterParams] = useState(null);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  const [filters, setFilters] = useState(null);
  const [dialog, setDialog] = useState({});
  const [loadingBtn, setLoadingBtn] = useState(false);


  const [loadingAgree, setLoadingAgree] = useState(false);
  const [loadingReject, setLoadingReject] = useState(false);
  const [creditorStatus, setCreditorStatus] = useState(false);
  const [loadingPage, setLoadingPage] = useState(false);
  const [activeTab, setActiveTab] = useState('1');
  const [captchaId, setCaptchaId] = useState(null);
  const [enteredCaptcha, setEnteredCaptcha] = useState('');
  const [projectId, setProjectId] = useState(0);

  const [submitLoading, setSubmitLoading] = useState(false);
  const [formData, setFormData] = useState(null);

  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [status, setStatus] = useState(''); // وضعیت تیکت در لیست تیکت ها

  const [baseLoading, setBaseLoading] = useState(true);
  const [file, setFile] = useState(null);
  const [filesUpoaded, setFilesUpoaded] = useState([]); // فایل های آپلود شده
  const [categories, setCategories] = useState([]); // dropDown category
  const [listServices, setListServices] = useState([]); // dropDown Service
  const [fields, setFields] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedService, setSelectedService] = useState(null);
  const [isServiceChangeLoading, setIsServiceChangeLoading] = useState(false);
  const [keyDom, setKeyDom] = useState(0);

  return {
    loadingAgree, setLoadingAgree,
    loadingReject, setLoadingReject,
    projectId, setProjectId,
    baseLoading,
    setBaseLoading,
    filesUpoaded,
    setFilesUpoaded,
    file,
    setFile,
    categories,
    setCategories,
    listServices,
    setListServices,
    fields,
    setFields,
    selectedCategory,
    setSelectedCategory,
    selectedService,
    setSelectedService,
    captchaId, setCaptchaId,
    isLoading,
    setIsLoading,
    status,
    setStatus,
    data,
    setData,
    submitLoading,
    setSubmitLoading,
    formData,
    setFormData,
    loading,
    setLoading,
    categoryLoading,
    setCategoryLoading,
    setFilterParams,
    size,
    setSize,
    filters,
    setFilters,
    dialog,
    setDialog,
    loadingBtn,
    setLoadingBtn,
    loadingPage,
    setLoadingPage,
    activeTab,
    setActiveTab,
    enteredCaptcha, setEnteredCaptcha,
    isServiceChangeLoading, setIsServiceChangeLoading,
    page, setPage,
    loadingSupport, setLoadingSupport,
    creditorStatus, setCreditorStatus,
    keyDom, setKeyDom
  };
};

export default useCustomHook;
